// An item's Default Method is a SET, not a single id.
//
// item_master.method used to be an int holding one method_master id. It now holds a comma list --
// "1,6" for an item measured in both Kgs and Readymade Nos -- fed from Item Category Master and
// overridable per item. This is the frontend half of backend/utils/methods.js and answers the
// same two questions:
//
//   methodIds(item.method)       every method the item is measured in
//   hasMethod(item.method, 6)    is this item measured that way AT ALL
//
// Do NOT compare the raw column to a number. parseFloat("1,6") is 1, so `num(method) === 6` reads
// only the first id and silently answers "no" for an item that is measured that way second --
// which is exactly why a Readymade item can show an empty Standard block on Production
// Estimation while its Consumption Master row sits there under method 6.
export const methodIds = (value) =>
  String(value ?? '')
    .split(',')
    .map((v) => parseInt(v, 10))
    .filter((n) => Number.isInteger(n) && n > 0);

export const hasMethod = (value, methodId) => methodIds(value).includes(Number(methodId));

// method_master id 6: an item counted in whole pieces rather than weighed -- Pav, papad, and the
// rest of the readymade items.
export const READYMADE_NOS = 6;
export const isReadymadeNos = (row) => hasMethod(row?.method, READYMADE_NOS);

// SQL list for `method IN (...)`. An item with no method yields IN (NULL), which matches nothing
// instead of breaking the statement -- and on /comman/batch-list one broken statement fails the
// whole batch ("id=1,2" did exactly that to Raw Material Estimation).
export const methodInList = (value) => methodIds(value).join(',') || 'NULL';

// Which method an item's numbers come from: the earliest of its methods that has a Consumption
// Master row, else its primary (first) method. Order matters -- never sort the list. `rows` are
// that item's consumption_master rows, fetched with `method IN (methodInList(value))`.
export const pickMethod = (value, rows = []) => {
  const ids = methodIds(value);
  for (const id of ids) {
    const consumption = (rows || []).find((r) => Number(r.method) === id);
    if (consumption) return { methodId: id, consumption };
  }
  return { methodId: ids[0] ?? null, consumption: null };
};
